import React from "react";
import { Formik, Form } from "formik";
import { withProps } from "recompose";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Column, PageContainer, Row } from "../Grid";
import { H1 } from "../TextStyles";
import { LargeButton } from "../Button";
import { Text } from "../../ui/Forms";
import schema from "./schema";
import chairUrlString from "../chairUrlString";
import SVGIcon from "../SVGIcon";

const TextField = withProps({ schema })(Text);

const FindChairForm = (props) => (
  <Form>
    <TextField name="manufactureCode" />
    <TextField placeholder="MM-DD-YYYY" name="manufactureDate" />
    <TextField name="invoiceNumber" />

    <LargeButton active type="submit" disabled={!props.isValid}>
      Find My Chair <SVGIcon icon="search" />
    </LargeButton>
  </Form>
);

const FindChair = ({ history }) => {
  const routeToChairDetails = (values) => {
    history.push(`/chair${chairUrlString(values)}`);
  };

  return (
    <PageContainer>
      <Helmet>
        <title>Find My Chair</title>
      </Helmet>
      <Row>
        <Column width={[1, 1, 1 / 2]}>
          <H1>Find My Chair</H1>
          <p>
            Enter your information below to access assembly and operational videos that will help
            you get the most out of your BioFit chair. You may also check the status of your 13-year
            warranty. Either way, we’ve made it quick and easy to gain access to the information you
            need!
          </p>
        </Column>
        <Column width={[1, 1, 1 / 2]} px="2rem">
          <Formik
            initialValues={{
              manufactureCode: "",
              manufactureDate: "",
              invoiceNumber: "",
            }}
            validationSchema={schema}
            onSubmit={routeToChairDetails}
            component={FindChairForm}
          />
        </Column>
      </Row>
    </PageContainer>
  );
};

export default withRouter(FindChair);
